import {QueryFunctionContext} from 'react-query';
import request from 'services/axios';

export const getFarmProducts = async () => {
  const {data}: {data: Array<IFarmProductsData>} = await request.get(
    `/api/v2/farm/products`,
  );
  return data;
};

export const getMahsul = async (ctx: QueryFunctionContext) => {
  const {data}: {data: IMahsul} = await request.get(
    `/api/v2/farm/mahsul?category_guid=${ctx.queryKey[1]}`,
  );
  return data;
};
